import { render, staticRenderFns } from "./oss.vue?vue&type=template&id=e35deee8&"
import script from "./oss.vue?vue&type=script&lang=js&"
export * from "./oss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports